/**
 * Lane FX-PORT: a ported skill sample (render/fx/sampleArt/skills.ts) as a port spec (render/fx/sampleArt/port.ts):
 * the sample's own `under` / `over` drawing, its afterimage times and its dash, on the game's scene.
 */
import type { V } from './kit';
import { registerPort, usePorts, type PortScene, type PortSpec } from './port';
import { SAMPLES, type Scene } from './skills';

type Timing = Pick<PortSpec, 'skills' | 'on' | 'pre' | 'hit' | 'end' | 'cast' | 'big' | 'dash' | 'stepIn'>;

/** Registers sample `id` for the moves in `timing.skills`. */
export function portSample(id: string, timing: Timing): void {
  const sample = SAMPLES.find((s) => s.id === id);
  if (!sample) throw new Error(`no fx sample '${id}'`);
  const scene = (s: PortScene): Scene => ({ ...s, sample });
  usePorts();
  registerPort({
    id,
    ...timing,
    big: timing.big ?? sample.big,
    move: sample.move ? (s, t): V => sample.move!({ ...s, sample, t, body: () => s.a, limbs: () => ({ hand: s.a, handB: s.a, tip: s.a }) }, t) : undefined,
    under: sample.under ? (g, s) => sample.under!(g, scene(s)) : undefined,
    over: (g, s) => sample.over(g, scene(s)),
  });
}
